import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Injectable()
export class ScholarAuthService {
baseUrl = environment.baseUrl
  url = this.baseUrl+'scholar';
  timer: any;
  constructor(private httpClient: HttpClient, private router: Router) { }
  public login(credentials) {
    return this.httpClient.post<any>(this.url + '/login', credentials).pipe(
      map(response => {
        if (response && response.token) {
          const jwtHelper = new JwtHelper()
          const ExpireTime = jwtHelper.decodeToken(response.token).expiresIn;
          this.timer = setTimeout(() => {
            this.logout()
          }, ExpireTime * 1000)
          localStorage.setItem('scholar-token', response.token);
          return true;
        }
        return false;
      })
    )
  }
  logout() {
    clearTimeout(this.timer)
    localStorage.removeItem('scholar-token');
    this.router.navigate(['/login/scholar'])
  }
  getUserName() {
    const jwtHelper = new JwtHelper()
    const token = localStorage.getItem('scholar-token')
    if (!token) return ""
    let name = jwtHelper.decodeToken(token).firstName + " " + jwtHelper.decodeToken(token).lastName
    return name;
  }
  getLoggedUserId() {
    const jwtHelper = new JwtHelper()
    const token = localStorage.getItem('scholar-token')
    if (!token) return ""
    let id = jwtHelper.decodeToken(token).id
    return id;
  }
  isLoggedIn() {
    return tokenNotExpired('scholar-token')
  }
  getToken() {
    const token = localStorage.getItem('scholar-token')
    if (!token) return '';
    return token
  }
  verify() {
    return this.httpClient.get<any>(this.url + '/isLoggedIn')
  }

}
